import { Component, OnInit, ComponentRef } from '@angular/core';
import {
  IModalDialog,
  IModalDialogOptions,
  IModalDialogButton,
} from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'alg-linear-modal',
  templateUrl: './alg-linear-modal.component.html',
  styleUrls: ['./alg-linear-modal.component.scss'],
})
export class AlgLinearModalComponent implements OnInit {
  actionButtons: IModalDialogButton[];
  public isOpenedFirstDescription = false;
  public isOpenedSecondDescription = false;
  public isOpenedThirdDescription = false;
  public firstPartGasDescription = [
    {
      includes:
        'sulle tubazioni private d’alimentazione del gas, a valle del punto di consegna',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'dal tubo o dai rubinetti di alimentazione della cucina o della caldaia fino ad un massimo di 2 interventi all’anno e con un massimale di € 1.000 per evento',
    },
  ];
  public firstPartLightDescription = [
    {
      includes:
        'all’impianto elettrico di distribuzione interna (compresi i danni causati da un fulmine)',
    },
    {
      includes: 'al quadro elettrico',
    },
    {
      includes: 'ad una presa elettrica',
    },
    {
      includes: 'ad un portalampada',
    },
    {
      includes: 'ad un interruttore',
    },
    {
      includes: 'al salvavita',
    },
  ];

  public secondGasPartDescription = [
    {
      includes:
        'le prestazioni non necessarie e non funzionali ad affrontare la situazione di difficoltà',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'gli aiuti alternativi se l’assicurato, per sua libera scelta o per sua negligenza non usufruisce o usufruisce solo parzialmente delle prestazioni ',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'i danni conseguenti ad un mancato o ritardato intervento di Linear dovuto all’intervento delle Autorità dello Stato nel quale è prestata l’assistenza o a causa di forza maggiore o circostanza fortuita ed imprevedibile',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'i danni da interruzione dell’attività, ovvero ai beni utilizzati o comunque sofferti nell’ambito dell’attività di natura professionale o commerciale a seguito di incidenti che avrebbero necessitato di manutenzione ordinaria o straordinaria',
    },
    {
      includes:
        'le eventuali spese sopravvenute in seguito all’ Intervento degli organismi locali o nazionali di soccorso di emergenza',
    },
    {
      includes:
        'le spese necessarie al ripristino di parti dell’abitazione interessate dall’intervento di assistenza',
    },
    { includes: 'le perdite di gas dalle tubazioni condominiali' },
    {
      includes:
        'le perdite di gas dalle tubazioni che partono dal contatore e vanno verso l’esterno',
    },
    {
      includes:
        'gli Interventi su elettrodomestici e apparecchi alimentati a gas (es. caldaie, boiler, fornelli ecc.)',
    },
  ];
  public secondLightPartDescription = [
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'le prestazioni non necessarie e non funzionali ad affrontare la situazione di difficoltà ',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'gli aiuti alternativi se l’assicurato, per sua libera scelta o per sua negligenza non usufruisce o usufruisce solo parzialmente delle prestazioni',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'i danni conseguenti ad un mancato o ritardato intervento di Linear dovuto all’intervento delle autorità del paese nel quale è prestata l’assistenza o a causa di forza maggiore o circostanza fortuita ed imprevedibile',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'i danni da interruzione dell’attività, ovvero ai beni utilizzati o comunque sofferti nell’ambito dell’attività di natura professionale o commerciale a seguito di incidenti che avrebbero necessitato di manutenzione ordinaria o straordinaria',
    },
    {
      includes:
        'le eventuali spese sopravvenute in seguito all’ intervento degli organismi locali o nazionali di soccorso di emergenza',
    },
    {
      includes:
        'le spese necessarie al ripristino di parti dell’abitazione interessate dall’intervento di assistenza',
    },
    {
      includes:
        // tslint:disable-next-line: max-line-length
        'gli interventi su elettrodomestici e apparecchi, impianti collettivi, cablaggio e qualsiasi elemento raccordato all’impianto fisso (antifurti, televisione, cablaggi telefonici, caldaie, boiler, fornelli, ecc.)',
    },
    {
      includes: 'le riparazioni e i ricambi relativi agli impianti domotici',
    },
  ];

  public thirdPartDescription = [
    {
      includes: 'dolo dell’assicurato o dei familiari conviventi',
    },
    {
      includes:
        'eventi naturali di carattere eccezionale laddove non sia oggettivamente possibile intervenire',
    },
    {
      includes:
        'atti di guerra, insurrezioni, tumulti popolari o atti violenti con movente politico ai quali l’assicurato abbia partecipato',
    },
    {
      includes: 'azioni delittuose dell’assicurato',
    },
    {
      includes:
        'eventi che hanno colpito parti di uso non esclusivo dell’abitazione',
    },
    {
      includes: 'interruzione della fornitura da parte degli enti erogatori',
    },
    {
      includes: 'corrosione, usura, gelo o stillicidio',
    },
    {
      includes: 'se gli impianti non sono a norma di legge',
    },
    {
      includes: 'danni conseguenti a interventi di messa a norma dell’impianto',
    },
  ];
  public type: string;
  private title: string;

  constructor(private utils: UtilsService, private gtm: AlgGtmService) {
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
      {
        text: 'Torna alla compilazione',
        buttonClass: 'button-cancel-product',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];
  }

  ngOnInit() {}

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<any>>
  ) {
    this.title = options.data.title;
    this.type = options.data.description;
  }

  openAccordion(type) {
    switch (type) {
      case 'firstDescription':
        this.isOpenedFirstDescription = !this.isOpenedFirstDescription;
        this.gtm.submitOnbEvent(
          'Visualizzazione faq',
          'Che cosa è assicurato?'
        );
        break;

      case 'secondDescription':
        this.isOpenedSecondDescription = !this.isOpenedSecondDescription;
        this.gtm.submitOnbEvent(
          'Visualizzazione faq',
          'Che cosa non è assicurato?'
        );
        break;

      case 'thirdDescription':
        this.isOpenedThirdDescription = !this.isOpenedThirdDescription;
        this.gtm.submitOnbEvent(
          'Visualizzazione faq',
          'Ci sono limiti di copertura?'
        );
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-linear-modal/alg-linear-modal.component.ts